import sanitizeHtml from "sanitize-html";

const sanitizeOptions = (videoUrl) => ({
  allowedTags: sanitizeHtml.defaults.allowedTags.concat(["iframe"]),
  allowedAttributes: {
    iframe: [
      "src",
      "width",
      "height",
      "frameborder",
      "allow",
      "allowfullscreen",
    ],
    "*": ["class", "style"],
  },
  allowedIframeHostnames: [videoUrl],
});

export function sanitize(content, videoUrl) {
  const processedVideoUrl = videoUrl.replace(/https?:\/\//, "");
  return sanitizeHtml(content, sanitizeOptions(processedVideoUrl));
}
